// /quiz/random ou /quiz/:id
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function QuizPage({ socket, prompt, email, userObj }) {
  const { theme } = useParams();
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [showExplanation, setShowExplanation] = useState(false);

  useEffect(() => {
    if (!theme) return;
    fetch(`${API_URL}/api/quiz/${theme}`)
      .then(res => res.json())
      .then(setQuestions);
  }, [theme]);

  if (!theme) return <div>Thème non défini</div>;
  if (questions.length === 0) return <div>Chargement...</div>;

  const question = questions[current];

  const handleAnswer = (i) => {
    const correct = i === question.correct;
    setFeedback(correct ? "✅ Bonne réponse !" : "❌ Mauvaise réponse.");
    if (correct) setScore(score + 1);
    setShowExplanation(true);
    // Si c’est la dernière question, afficher le score immédiatement
  if (current + 1 === questions.length) {
    setTimeout(() => {
      alert(`Quiz terminé ! Score : ${score + (correct ? 1 : 0)} / ${questions.length}`);
    }, 500); // petit délai pour que le feedback s'affiche
  }
  };

  const handleNext = () => {
  setFeedback("");
  setShowExplanation(false);
 
  if (current + 1 < questions.length) {
    setCurrent(current + 1);
  } else {
         alert(`Quiz terminé ! Score : ${score} / ${questions.length}`);
 
  }
};

  return (
    <div className="quiz-container">
      {question.intro && current === 0 && <p className="quiz-intro">{question.intro}</p>}

      <h2>Question {current + 1} / {questions.length}</h2>
      <p>{question.text}</p>

      {question.options.map((opt, i) => (
        <button
          key={i}
          onClick={() => handleAnswer(i)}
          disabled={!!feedback}
        >
          {opt}
        </button>
      ))}

      {feedback && ( <div className={`quiz-feedback ${feedback.includes("✅") ? "correct" : "incorrect"
    }`}
  >
    {feedback}
  </div>
)}
      {showExplanation && question.explanation && (
        <div className="quiz-explanation">{question.explanation}</div>
      )}

     {showExplanation && current + 1 < questions.length && (
        <button className="quiz-next" onClick={handleNext}>
          Question suivante
        </button>
      )}
    </div>
  );
}
